<template>
    <div class="row">
        <div class="col-md-12 col-sm-6 col-12">
            <div id="social" class="">
                <div class="car-header">
                    <h5 class="m-0 p-2">VOLG ONS <br /> OP SOCIAL MEDIA</h5>
                </div>
                <ul class="list-unstyled m-0 pt-2 row">
                    <li class="d-inline-block col-4 text-right" v-if="fburl">
                        <a v-bind:href="fburl" target="_blank">
                            <i class="fab fa-facebook-square"></i>
                        </a>
                    </li>
                    <li class="d-inline-block col-4" v-if="instagramurl">
                        <a v-bind:href="instagramurl" target="_blank">
                            <i class="fab fa-instagram"></i>
                        </a>
                    </li>
                    <li class="d-inline-block col-4" v-if="tiktokurl">
                        <a v-bind:href="tiktokurl" target="_blank">
                            <i class="fab fa-tiktok"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name:"sidebar-social",
        props:{
            fburl : {
                type: String,
            },
            instagramurl :{
                type: String,
            },
            tiktokurl :{
                type: String,
            },
        },
        data(){
            return {
                
            }
        },
    }
</script>

<style scoped>
    .fab{
        color: #000;
    }
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/sidebar-social.vue